import { Component, Input, Output, EventEmitter, HostListener, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

import { CnpjPipe } from '../../pipes/cnpj.pipe';
import { I18nPipe } from '../../pipes/i18n.pipe';
import { FixaResource } from '../../../core/models/login.model';
import { formatFixaContractDisplayFromList } from '../../../core/utils/fixa-contract-display.util';

@Component({
  selector: 'umkt-cnpj-selector',
  standalone: true,
  imports: [CommonModule, CnpjPipe, I18nPipe],
  templateUrl: './cnpj-selector.component.html',
  styleUrls: ['./cnpj-selector.component.scss']
})
export class CnpjSelectorComponent {
  private router = inject(Router);
  
  @Input() cnpjList: string[] = [];
  @Input() contractList: FixaResource[] = [];
  @Input() selectedCnpj: string = '';
  @Input() selectedContractId: string = '';
  @Input() companyName: string = '';
  @Input() fallbackText: string = '';
  @Input() isFixaMode: boolean = false;
  @Input() isLoading = false;
  @Output() cnpjChange = new EventEmitter<string>();
  @Output() contractChange = new EventEmitter<string>();

  isDropdownOpen = false;

  get displayList(): string[] {
    if (this.isFixaMode) {
      return this.activeFixaContracts.map(contract => String(contract.customerAccountId ?? ''));
    }
    return this.cnpjList;
  }

  private get activeFixaContracts(): FixaResource[] {
    const activeStatuses = ['ACTIVE', 'CONECTADO'];
    return this.contractList.filter(contract =>
      activeStatuses.includes(contract.status?.toUpperCase?.() ?? '')
    );
  }

  fixaContractLabel(customerAccountId: string): string {
    return formatFixaContractDisplayFromList(this.contractList, customerAccountId);
  }

  fixaContractByCustomerAccountId(customerAccountId: string): FixaResource | undefined {
    const id = String(customerAccountId ?? '');
    return this.contractList.find(c => String(c.customerAccountId ?? '') === id);
  }

  get selectedValue(): string {
    if (this.isFixaMode) {
      return this.selectedContractId;
    }
    return this.selectedCnpj;
  }

  toggleDropdown(): void {
    if (this.isLoading) {
      return;
    }
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  onSelectCnpj(value: string): void {
    if (this.isLoading) {
      return;
    }

    if (this.isFixaMode) {
      if (value !== this.selectedContractId) {
        this.selectedContractId = value;
        this.contractChange.emit(value);
      }
    } else {
      if (value !== this.selectedCnpj) {
        this.selectedCnpj = value;
        this.cnpjChange.emit(value);
      }
    }
    this.isDropdownOpen = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.cnpj-selector-dropdown')) {
      this.isDropdownOpen = false;
    }
  }
}

